import { render } from "./archived_schools.vue?vue&type=template&id=3c1788d4"
import script from "./archived_schools.vue?vue&type=script&lang=js"
export * from "./archived_schools.vue?vue&type=script&lang=js"

import "./archived_schools.vue?vue&type=style&index=0&id=3c1788d4&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__